"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ObjectId = require('bson').ObjectID;

var clone = require('clone');

var tv4 = require('tv4');

var PersonReference = require('../core/person-reference');

var Flag = /*#__PURE__*/function () {
  function Flag(opt) {
    _classCallCheck(this, Flag);

    this.id = null;
    this.reviewer = null;
    this.date = null;
    this.type = null;
    this.problem = null;

    if (opt) {
      this.fillObject(clone(opt));
    }
  }

  _createClass(Flag, [{
    key: "fillObject",
    value: function fillObject(opt) {
      this.id = new ObjectId(opt.id);
      this.reviewer = opt.reviewer ? new PersonReference(opt.reviewer) : null;
      this.date = opt.date ? new Date(opt.date) : new Date();
      this.type = opt.type;
      this.problem = opt.problem;
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, Flag.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'flag.schema.json',
        type: 'object',
        properties: {
          id: {
            type: 'object'
          },
          reviewer: {
            $ref: 'person-reference.schema.json'
          },
          date: {
            type: ['object', 'null']
          },
          type: {
            type: 'string'
          },
          problem: {
            type: 'string'
          }
        },
        required: Object.keys(this)
      };
    }
  }]);

  return Flag;
}();

tv4.addSchema(PersonReference.schema());
module.exports = Flag;